import React from 'react'

import { EChart } from '@/components/charts/EChart'
import { buildLineOption } from '@/components/charts/nivoToEcharts.helpers'

// Renders on ECharts but keeps the nivo line prop shapes its consumers pass
// (series data, xScale/yScale, axis configs, { point } tooltip functions).
// trendlines replaces the old nivo canvas-layers regression drawing:
// [{ serieId, color }] appends a dashed least-squares segment per entry.
const LineChart = (props) => (
  <EChart option={buildLineOption(props)} style={{ width: '100%', height: '100%' }} />
)

export default LineChart
